export const newsData = [
         {
    date: "25.12.2025",
    title: 'ПОСТАНОВЛЕНИЕ ОБ ИЗМЕНЕНИИ ТАРИФОВ НА 2026Г.',
    url: '/o-tarifax-2026'
    },
        {
    date: "23.09.2025",
    title: 'ПОСТАНОВЛЕНИЕ О НАЧАЛЕ ОТОПИТЕЛЬНОГО ПЕРИОДА 2025-2026 ГГ.',
    url: '/o-nachale-otopitelnogo-perioda-2025-2026-gg'
    },
      {
    date: "04.08.2025",
    title: 'РЕШАЙТЕ ВОПРОСЫ С НЕДВИЖИМОСТЬЮ В БТИ',
    url: '/nedvizhimost-s-bti'
    },
    {
    date: "10.06.2025",
    title: 'ПЛАТИТЕ ЗА ЖКУ ОНЛАЙН',
    url: '/zhku-online'
    },
  {
    date: "15.05.2025",
    title: 'ПОСТАНОВЛЕНИЕ ОБ ОКОНЧАНИИ ОТОПИТЕЛЬНОГО ПЕРИОДА 2024-2025 ГГ.',
    url: '/postanovlenie-ob-okonchanii-otopitelnogo-perioda-2024-2025-gg'
    },
      {
    date: "21.04.2025",
    title: 'ОБ ОКОНЧАНИИ ОТОПИТЕЛЬНОГО ПЕРИОДА 2024-2025 ГГ.',
    url: '/ob-okonchanii-otopitelnogo-perioda-2024-2025-gg'
    },
  {
    date: "31.03.2025",
    title: 'СТАРТ ПЕРВЫХ ЭКОЛОГИЧЕСКИХ ИГР В ПОДМОСКОВЬЕ',
    url: '/ecoigry'
    },
  {
  date: "24.01.2025",
  title: 'КАК ПЕНИ ЗА НЕСВОЕВРЕМЕННУЮ ОПЛАТУ МОГУТ УВЕЛИЧИТЬ КОММУНАЛЬНЫЙ СЧЕТ',
  url: '/o-penyax'
  },
  {
    date: "11.12.2024",
    title: 'СРОКИ ВЫПУСКА ПЛАТЕЖНЫХ ДОКУМЕНТОВ В ПРЕДВЕРИИ НОВОГО ГОДА',
    url: '/sroki-vypuska-platezhnyx-dokumentov'
  },
  {
    date: "11.12.2024",
    title: 'ВМЕСТО БУМАЖНЫХ ПЛАТЕЖЕК – ЭЛЕКТРОННЫЕ: УДОБНО И ЭКОЛОГИЧНО!',
    url: '/o-epg'
  },
  {
    date: "27.11.2024",
    title: 'ИНФОРМИРОВАНИЕ ЖИТЕЛЕЙ О ПРЕИМУЩЕСТВАХ ПЕРЕХОДА НА ЭЛЕКТРОННЫЙ ЕДИНЫЙ ПЛАТЕЖНЫЙ ДОКУМЕНТ',
    url: '/informirovanie-o-epg'
  },
  {
    date: "02.10.2024",
    title: 'О НАЧАЛЕ ОТОПИТЕЛЬНОГО ПЕРИОДА 2024-2025 ГГ.',
    url: '/o-nachale-otopitelnogo-perioda-2024-2025-gg'
  },
  {
    date: "15.08.2024",
    title: 'ИНФОРМИРОВАНИЕ НАСЕЛЕНИЯ О ПОЛУЧЕНИИ ЭЛЕКТРОННОГО ЕДИНОГО ПЛАТЕЖНОГО ДОКУМЕНТА (ЭЕПД)',
    url: '/ob-elektronnom-edinom-platezhnom-dokumente'
  },
  {
    date: "12.07.2024",
    title: 'ИНФОРМИРОВАНИЕ ЖИТЕЛЕЙ О НЕОБХОДИМОСТИ НАДЛЕЖАЩЕГО ВЫВОЗА СТРОЙОТХОДОВ',
    url: '/o-zaprete-vybrosa-stroyothodov-v-baki-u-doma'
  },
  {
    date: "25.04.2024",
    title: 'ОБ ОКОНЧАНИИ ОТОПИТЕЛЬНОГО ПЕРИОДА 2023-2024 ГГ.',
    url: '/ob-okonchanii-otopitelnogo-perioda-2023-2024-gg'
  },

    {
      date: "05.10.2023",
      title: 'ПРОСТО О ЖКХ',
      url: '/prosto-o-zhkh'
    },

    {
      date: "26.04.2023",
      title: 'ОБ ОКОНЧАНИИ ОТОПИТЕЛЬНОГО ПЕРИОДА 2022-2023 ГГ.',
      url: '/ob-okonchanii-otopitelnogo-perioda-2022-2023-gg'
    },

    {
      date: "23.09.2022",
      title: 'ВОПРОСЫ О НАЧИЛЕНИЯХ ЗА ЖКУ?',
      url: '/voprosy-o-nachileniyakh-za-zhku'
    },

    {
      date: "01.07.2022",
      title: 'ИЗМЕНЕНИЕ ТАРИФОВ ЖКС С 01.07.2022 Г.',
      url: '/izmenenie-tarifov-zhks-s-01.07.2022-g'
    },

    {
      date: "31.05.2022",
      title: 'ЖИТЕЛЕЙ ОКРУГА ПУШКИНСКИЙ ОЖИДАЕТ УВЛЕКАТЕЛЬНОЕ ПУТЕШЕСТВИЕ В ДЕТСТВО',
      url: '/zhitelej-okruga-pushkinskij-ozhidaet-uvlekatelnoe-puteshestvie-v-detstvo'
    },

    {
      date: "08.04.2022",
      title: 'ЛИСТОВКА ДЛЯ СТЕНДА С QR-КОДОМ',
      url: '/listovka-dlya-stenda-s-qr-kodom'
    },






  ];